import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { createdResponse, notFoundResponse, removedResponse, updatedResponse } from '../../../routes/defaultResponses';
import { ObjectTypeFieldDataType } from './ObjectTypeFieldDataType';

const objectTypeFieldSchema = Type.Object({
    id: Type.String(),
    name: Type.String({ minLength: 1 }),
    objectTypeId: Type.String(),
    unit: Type.String(),
    dataType: Type.Enum(ObjectTypeFieldDataType),
    listOptions: Type.Array(Type.Object({ value: Type.String() })),
    category: Type.String(),
    order: Type.Integer({ minimum: 0 }),
    clientCompanyId: Type.String({ minLength: 1, format: 'uuid' }),
});

const objectTypeFieldCreateAndUpdateSchema = Type.Pick(objectTypeFieldSchema, [
    'name',
    'unit',
    'dataType',
    'listOptions',
    'category',
    'order',
    'clientCompanyId',
]);

const objectTypeFieldSelectSchema = Type.Intersect([objectTypeFieldSchema, Type.Object({ clientCompany: Type.Object({ name: Type.String() }) })]);

export const objectTypeFieldPaths = {
    '/api/objectTypes/{objectTypeId}/objectTypeFields': {
        get: {
            operationId: 'objectTypeFieldControllers.getAll',
            parameters: [
                createPathGuidParameter('objectTypeId'),
                { name: 'clientCompanyId', in: 'query', required: false, schema: Type.String({ format: 'uuid' }) },
            ],
            responses: {
                '200': {
                    description: 'Array of object type fields',
                    content: {
                        'application/json': {
                            schema: Type.Object({ items: Type.Array(objectTypeFieldSelectSchema) }),
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        post: {
            parameters: [createPathGuidParameter('objectTypeId')],
            operationId: 'objectTypeFieldControllers.create',
            requestBody: {
                content: {
                    'application/json': {
                        schema: objectTypeFieldCreateAndUpdateSchema,
                    },
                },
            },
            responses: {
                ...createdResponse,
                ...notFoundResponse,
            },
        },
    },
    '/api/objectTypes/{objectTypeId}/objectTypeFields/{objectTypeFieldId}': {
        parameters: [createPathGuidParameter('objectTypeId'), createPathGuidParameter('objectTypeFieldId')],
        get: {
            operationId: 'objectTypeFieldControllers.get',
            responses: {
                '200': {
                    description: 'Array of object type fields',
                    content: {
                        'application/json': {
                            schema: objectTypeFieldSchema,
                        },
                    },
                },
                ...notFoundResponse,
            },
        },
        delete: {
            operationId: 'objectTypeFieldControllers.remove',
            responses: {
                ...removedResponse,
                ...notFoundResponse,
            },
        },
        post: {
            operationId: 'objectTypeFieldControllers.update',
            requestBody: {
                content: {
                    'application/json': {
                        schema: objectTypeFieldCreateAndUpdateSchema,
                    },
                },
            },
            responses: {
                ...updatedResponse,
                ...notFoundResponse,
            },
        },
    },
} as const;
